import z from 'zod/v3';

const ReferredPaymentSchema = z.object({
  referredUser: z.object({
    name: z.string(),
    email: z.string(),
  }),
  referredOrg: z.object({
    name: z.string(),
  }),
  referredPaymentReceivedAt: z.date({ coerce: true }),
  referredPaymentAmount: z.number(),
  payoutFormulaId: z.string(),
  commissionAmount: z.number(),
  commissionDisbursedAt: z.date({ coerce: true }).nullable(),
});

export type ReferredPayment = z.infer<typeof ReferredPaymentSchema>;
